import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tag, Sparkles } from "lucide-react";
import { mailboxApi } from "@/lib/api";
import { useToast } from "@/components/SimpleToast";
import { useMailboxTopics } from "./useMailboxTopics";

export function TopicSelect({ email, canEdit, onChanged }) {
  const topics = useMailboxTopics();
  const toast = useToast();
  const current = topics.find((t) => t.id === email.topic_id);
  const label = current ? current.name : "Wird eingeordnet…";

  if (!canEdit) {
    return <span className="inline-flex items-center gap-1 text-xs text-muted-foreground"><Tag className="w-3 h-3" />{label}</span>;
  }
  const change = async (topicId) => {
    try {
      await mailboxApi.setTopic(email.id, topicId);
      toast.success("Thema geändert");
      onChanged?.();
    } catch {
      toast.error("Thema konnte nicht geändert werden");
    }
  };
  return (
    <Select value={email.topic_id || ""} onValueChange={change}>
      <SelectTrigger className="h-7 w-auto gap-1 px-2 text-xs border-dashed" title={email.topic_source === "ai" ? "Von der KI eingeordnet – zum Ändern klicken" : "Thema"} data-testid={`mail-topic-${email.id}`}>
        {email.topic_source === "ai" ? <Sparkles className="w-3 h-3 text-primary" /> : <Tag className="w-3 h-3" />}
        <SelectValue placeholder={label}>{label}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {topics.map((t) => <SelectItem key={t.id} value={t.id} data-testid={`mail-topic-option-${t.id}`}>{t.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
